import moment from "moment";
import reminder_template from "./reminder";
import config from "lib/config";

const DATE_FORMAT =
  config && config.shortDateFormat && config.shortDateFormat.toUpperCase();

const item_template = {
  title: "",
  checklistItemTypeID: 1,
  deadlineID: null,
  courseID: null,
  description: "",
  priority: null,
  courseObjectID: null,
  itemOrder: null,
  deadline: moment().add(1, "months").format(DATE_FORMAT),
  completed: null,
  completedBy: null,
  completedByName: null,
  completedDate: null,
  reminder: reminder_template,
};

export default item_template;
